import { ALL_PLAYER_RATES_COURSE } from 'common/utils';
import useGlobalStore from 'store/global';
import styles from './PlayerRateOptions.module.scss';

const PlayerRateOptions = ({
  playbackRate,
  setPlaybackRate,
}: {
  playbackRate: number;
  setPlaybackRate: (rate: number) => void;
}) => {
  const currentAuth = useGlobalStore((state) => state.currentAuth);
  const showLogin = useGlobalStore((state) => state.showLogin);
  return (
    <div className={styles.speedCtrl} onClick={(e) => e.stopPropagation()}>
      <div className={styles.speedCtrlOptions}>
        {ALL_PLAYER_RATES_COURSE.map((rate, index) => {
          return (
            <div
              onClick={() => {
                if (!currentAuth) {
                  showLogin({});
                  return;
                }
                setPlaybackRate(rate);
              }}
              className={styles.text}
              key={`option-${index}`}
            >
              <div className={styles.content}>{rate}x</div>
            </div>
          );
        })}
      </div>
      <div className={styles.speedBtn}>{playbackRate}x</div>
    </div>
  );
};

export default PlayerRateOptions;
